import React from "react"
import { styled } from "@mui/material/styles"
import { Swiper, SwiperSlide } from "swiper/react"
import { Virtual } from "swiper/modules"
import "swiper/css"
import { useAppSelector } from "appRedux/hooks"
import SliderProgressBar from "components/atoms/Slider/SliderProgressBar"
import LoadingPlaceholder from "components/atoms/Slider/LoadingPlaceholder"

type SliderProps = {
  list: any[];
  showProgressBar: boolean;
  isLoading: boolean;
  render: (slide: any, index: number) => React.ReactNode;
  onChange: (currentSlide: number) => void;
}

export default function Slider(props: SliderProps) {
  const {
    list,
    showProgressBar = true,
    isLoading,
    render,
    onChange
  } = props

  const currentItemIndex = useAppSelector((state) => state.wishList.currentItemIndex)
  const wishListState = useAppSelector((state) => state.wishList)

  function handleOnSlideChange(swiperEvent: any) {
    onChange(swiperEvent.activeIndex)
  }

  function handleOnTap(swiperEvent: any) {
    const { startX } = swiperEvent.touches
    const slideWidth = swiperEvent.width
    const tapNonSensitiveAreaWidth = slideWidth * 0.2
    if (startX < slideWidth / 2 - tapNonSensitiveAreaWidth) {
      swiperEvent.slidePrev()
    } else if (startX > slideWidth / 2 + tapNonSensitiveAreaWidth) {
      swiperEvent.slideNext()
    }
  }

  return (
    <SliderWrapper id="swiper-wrapper">
      {currentItemIndex > -1 ? <>
        {(!isLoading || wishListState.itemInfo) ? <>
          <Swiper
            dir="ltr"
            initialSlide={currentItemIndex}
            touchStartPreventDefault={false}
            edgeSwipeDetection={true}
            modules={[Virtual]}
            virtual
            onSlideChange={handleOnSlideChange}
            onTap={handleOnTap}
          >
            {list.map((item: WishItem, index: number) => (
              <SwiperSlide key={item.id} virtualIndex={item.id}>{render(item, index)}</SwiperSlide>
            ))}
          </Swiper>
        </> : <LoadingPlaceholder/>
        }
        {showProgressBar && <SliderProgressBar total={list.length} current={currentItemIndex}/>}
      </> : isLoading ? <LoadingPlaceholder/> : null}
    </SliderWrapper>
  )
}

const SliderWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "100%"
}))
